import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ItineraryComponent from 'components/itinerary/itinerary';
import { getItinerary } from '../../actions/itinerary';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getItinerary
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        currentUser: state.currentUser,
        itinerary: state.itinerary
    };
}

const Itinerary = connect(
    mapStateToProps,
    mapDispatchToProps
)(ItineraryComponent);

export default Itinerary;


// WEBPACK FOOTER //
// ./src/app/containers/itinerary/itinerary.jsx